import React, { useState } from 'react';
import Script from 'next/script';

import { IVideoBlockFields } from '../../../types/contentful';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';

import { Layout, Column } from '../Layout';
import { Lightbox } from './Lightbox';

import { BlockContainerBgImage, VideoButton, PlayIcon } from './styles';

export function VideoBlock({
  title,
  vimeoId,
  backgroundImage
}: IVideoBlockFields) {
  const [showingVideo, setShowingVideo] = useState(false);

  const toggleVideo = (displayVideo: boolean) => {
    setShowingVideo(displayVideo);
    if (displayVideo) {
      trackWithFingerprint('Video Opened', {
        page_url: window.location.href
      });
    } else {
      trackWithFingerprint('Video Closed', {
        page_url: window.location.href
      });
      document.getElementById('gl-video-play-button')?.focus();
    }
  };

  const { file } = backgroundImage?.fields ?? {};

  return (
    <>
      <Script src="https://player.vimeo.com/api/player.js" />
      <BlockContainerBgImage
        backgroundImage={file?.url || undefined}
        marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        data-blockid="videoBlock"
        data-testid="video-block"
      >
        <Layout
          padding={{ 0: ['2xl', 0], tablet: ['4xl', 0], desktop: ['5xl', 0] }}
        >
          <Column
            size={{ 0: 3, tablet: 2 }}
            padding={{ 0: 0, desktop: ['2xl', 0] }}
          >
            <VideoButton
              id="gl-video-play-button"
              onClick={(e) => {
                toggleVideo(true);
                e.currentTarget.blur();
              }}
              aria-label="Play video"
            >
              <PlayIcon
                width="221"
                height="221"
                viewBox="0 0 221 221"
                role="img"
                aria-label="Play video"
              >
                <path
                  className="playIconBackground"
                  d="M0 56C0 25.072 25.0721 0 56 0H164.482C195.41 0 220.482 25.0721 220.482 56V164.482C220.482 195.41 195.41 220.482 164.482 220.482H56C25.072 220.482 0 195.41 0 164.482V56Z"
                  fill="#035C67"
                />
                <path
                  className="playIconCenter"
                  d="M145.086 102.266C150.419 105.345 150.419 113.043 145.086 116.123L97.2475 143.742C91.9141 146.821 85.2474 142.972 85.2474 136.814L85.2475 81.5748C85.2475 75.4164 91.9141 71.5674 97.2475 74.6466L145.086 102.266Z"
                  fill="#80D6B0"
                />
              </PlayIcon>
            </VideoButton>
            {vimeoId && title && (
              <Lightbox
                title={title}
                showingVideo={showingVideo}
                setShowingVideo={toggleVideo}
                vimeoId={vimeoId}
                aria-label="video"
              />
            )}
          </Column>
        </Layout>
      </BlockContainerBgImage>
    </>
  );
}
